import BackIcon from '../../assets/logo/BackIcon';
import useTheme from '../../hooks/ui/useTheme';
import { SCREENS } from '../../services/exports/Constants';
import DomainResource from '../../services/resources/DomainResource';
import classnames from 'classnames';
import useConfig from '../../hooks/ui/useConfig';
import CloseCircleIcon from '../../assets/icons/CloseCircleIcon';
import useMobileApp from '../../hooks/mobile-app/useMobileApp';
import WindowResource from '../../services/resources/WindowResource';

interface Props {
  type?: 'page';
  title?: string | JSX.Element;
  backIconTitle?: string;
  closeIconTitle?: string;
  hideBackIcon?: boolean;
  hideCloseIcon?: boolean;
  customRightAction?: any;
  transparent?: boolean;
  containerClassName?: string;
  showCompanyLogo?: boolean;
  customCenterElement?: React.ReactNode;
  rightClick?: () => void;
  leftClick?: () => void;
}

export default function CustomNavBar(props: Props) {
  const {
    type,
    title,
    backIconTitle,
    closeIconTitle,
    hideBackIcon,
    hideCloseIcon,
    transparent,
    showCompanyLogo,
    containerClassName,
    customRightAction,
    rightClick,
    leftClick,
  } = props;

  const { logo_url } = useConfig();
  const theme = useTheme();
  const { isMobileApp } = useMobileApp();

  const domain = DomainResource.getDomain();

  const extraSpacing: boolean = !!backIconTitle || !!closeIconTitle;

  function goBack(): void {
    WindowResource.replace(`${domain}${SCREENS.HOME_SCREEN}`);
  }

  return (
    <div
      className={classnames(
        'w-full grid p-md',
        {
          'p-xs': isMobileApp,
          'p-md': !isMobileApp,
          'grid-cols-9': extraSpacing,
          'grid-cols-5': !extraSpacing,
          'border-none': transparent,
          'border-b': !transparent,
        },
        containerClassName,
      )}
    >
      <button className={leftContainer(extraSpacing)} onClick={!hideBackIcon && leftClick ? leftClick : null}>
        {!hideBackIcon && (
          <div className={leftWrapper}>
            <div
              className={classnames(iconContainer, {
                'shadow-transparent bg-transparent': type === 'page',
              })}
            >
              <BackIcon className="h-3 !w-3" color={theme.color.brand.icon.color} />
            </div>
            {backIconTitle && (
              <p
                className={classnames(backIconDescription, {
                  'text-base': type === 'page',
                })}
              >
                {backIconTitle}
              </p>
            )}
          </div>
        )}
      </button>
      <div className={centerContainer(extraSpacing)}>
        <h4 className={titleStyle(showCompanyLogo)}>{title}</h4>
        {logo_url && showCompanyLogo && (
          <button onClick={goBack}>
            <img src={logo_url} alt="Logo" className={companyLogoStyle} />
          </button>
        )}
      </div>
      <button className={rightContainer(extraSpacing)} onClick={!hideCloseIcon && rightClick ? rightClick : null}>
        {customRightAction ??
          (!hideCloseIcon && (
            <div className={rightWrapper}>
              {closeIconTitle && <p className="mr-xs text-xs">{closeIconTitle}</p>}
              <CloseCircleIcon />
            </div>
          ))}
      </button>
    </div>
  );
}

const leftContainer = (extraSpacing?: boolean) =>
  `${extraSpacing ? 'lg:col-span-2 col-span-3' : ''}  flex items-center`;

const leftWrapper = 'flex flex-1 items-center';

const centerContainer = (extraSpacing?: boolean) =>
  `${extraSpacing ? 'lg:col-span-5 col-span-3' : 'col-span-3'} flex justify-center items-center`;

const rightContainer = (extraSpacing?: boolean) =>
  `${extraSpacing ? 'lg:col-span-2 col-span-3' : ''} flex justify-end items-center`;

const rightWrapper = 'flex flex-1 items-center justify-end';

const iconContainer =
  'rounded-full shadow-icon dark:shadow-none w-[28px] h-[28px] flex items-center justify-center bg-brand-icon-background-primary border border-brand-border';

const companyLogoStyle = 'h-[36px] lg:hidden flex';

const titleStyle = (hidden: boolean) => `text-center ${hidden ? 'lg:flex hidden' : ''}`;

const backIconDescription = 'ml-xs text-xs';
